export default __webpack_public_path__ + "64faac9ba1d1446ac7209908c0acbdaa.svg";